module.exports = __webpack_public_path__ + "static/media/IconTemplates_-23.2902f251.svg";